<div id="body-container" class="body-container" [ngClass]="currentTheme">
  <div id="theme-toggler" class="theme-toggler animate-on-hover" (click)="toggleTheme()">
  <icon-theme-toggler class="w-100 h-100"></icon-theme-toggler>
  </div>
  <div id="global-backdrop">
    <img src="./../assets/icons/close-icon-thin.svg" alt="Close button" title="close button" class="close-button" />
  </div>
  <router-outlet></router-outlet>
</div>
